import { UserIcon } from 'lucide-react';

import { StatusTimelineLoading } from '@components/timelines/StatusLoading';
import { Skeleton } from '@components/ui/skeleton';

export function ServiceRequestDetailsLoading() {
  return (
    <div className="grid py-4 lg:p-0">
      <div className="border-secondary mb-6 grid gap-y-8 border-b-2 border-dotted pb-2 lg:grid-cols-2 lg:gap-4 xl:grid-cols-3">
        <div className="relative grid grid-rows-[auto_1fr] gap-2">
          <div className="flex h-fit items-center gap-1">
            <UserIcon size={24} strokeWidth={1.5} />
            <Skeleton className="ml-4 h-8 w-6/12" />
            <Skeleton className="mr-auto h-8 w-8" />
            <Skeleton className="size-8 rounded-full" />
            <Skeleton className="size-8 rounded-full" />

            <Skeleton className="h-8 w-4" />
          </div>
          <div className="flex w-fit gap-x-2">
            <Skeleton className="size-15 rounded-lg" />
            <Skeleton className="size-15 rounded-lg" />
            <Skeleton className="size-15 rounded-lg" />
          </div>
        </div>
        <div className="border-secondary mb-2 border-dotted px-4 pb-8 xl:border-r-2">
          <div className="mb-4 flex justify-between">
            <Skeleton className="h-8 w-8/12" />
            <Skeleton className="h-8 w-4" />
          </div>

          <div className="grid grid-cols-2 gap-1">
            <Skeleton className="h-3.5 w-6/12" />
            <Skeleton className="h-3.5 w-6/12" />
            <Skeleton className="mb-2 h-4 w-full" />
            <Skeleton className="mb-2 h-4 w-full" />
            <Skeleton className="col-span-2 h-3.5 w-6/12" />
            <Skeleton className="col-span-2 mb-2 h-4 w-full" />
            <Skeleton className="col-span-2 h-3.5 w-6/12" />
            <Skeleton className="col-span-2 mb-2 h-4 w-full" />
            <Skeleton className="h-3.5 w-6/12" />
            <Skeleton className="h-3.5 w-6/12" />
            <Skeleton className="mb-2 h-4 w-full" />
            <Skeleton className="mb-2 h-4 w-full" />
          </div>
        </div>

        <div className="mx-auto h-full w-auto max-w-xs space-y-6 overflow-clip sm:max-w-full md:p-2 lg:col-span-2 xl:col-span-1 2xl:mx-0">
          <StatusTimelineLoading length={3} />
        </div>
      </div>
    </div>
  );
}
